// extracted by mini-css-extract-plugin
module.exports = {"ganttVerticalContainer":"gantt_ganttVerticalContainer__3jys7","horizontalContainer":"gantt_horizontalContainer__3olJ8","wrapper":"gantt_wrapper__A5KEa"};